import queuedJobLogsHandler from "../../services/QueuedJobLogs";

export default {
    async loadQueuedJobLogs({commit, dispatch}, payload) {
        const {data} = await queuedJobLogsHandler.all(payload);

        commit('SET_QUEUED_JOB_LOGS', data);
    }
}
